import { createHashHistory, createBrowserHistory } from "history";

// const hashHistory = createHashHistory();
// export default hashHistory;

export const browserHistory = createBrowserHistory();
